import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AppSettings {
	isSoundTurnOn: boolean;
	isShowRefundOn: boolean;
	isShowDiscountOn: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class AppSettingsService {
	public appSettingsKey = 'appSettings';
	public appSettings$ = new BehaviorSubject({
		isSoundTurnOn: false,
		isShowRefundOn: false,
		isShowDiscountOn: true,
	});

	constructor() {
		this.checkAppSettings();
	}

	private save(settings: AppSettings) {
		localStorage.setItem(this.appSettingsKey, JSON.stringify(settings));
		this.appSettings$.next(settings);
	}

	checkAppSettings() {
		try {
			const result = localStorage.getItem(this.appSettingsKey);
			if (result) {
				this.appSettings$.next(JSON.parse(result));
			}
		} catch (e) {}
	}

	toggleMusic() {
		const current = this.appSettings$.value;

		const updated = {
			...current,
			isSoundTurnOn: !current.isSoundTurnOn,
		};

		this.save(updated);
	}

	toggleShowRefund() {
		const current = this.appSettings$.value;

		const updated = {
			...current,
			isShowRefundOn: !current.isShowRefundOn,
		};

		this.save(updated);
	}

	toggleShowDiscount() {
		const current = this.appSettings$.value;

		const updated = {
			...current,
			isShowDiscountOn: !current.isShowDiscountOn,
		};

		this.save(updated);
	}
}
